export default __webpack_public_path__ + "static/media/scw-grid-3.55a79873.svg";